import { Button } from "@msuite/ui/button";
import { Select } from "@msuite/ui/form";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { moment } from "@msuite/utils/date";
import type { AbsenceGeneralFormSchema } from "@msuite/utils/schemas";
import { useFieldArray, useFormContext } from "react-hook-form";

export function HalfDaysField() {
	const methods = useFormContext<AbsenceGeneralFormSchema>();

	/** Hooks */
	const { t } = useTranslation();
	const { fields, append, remove } = useFieldArray({
		control: methods.control,
		name: "halfVacationDays",
	});

	/** Render */
	return (
		<>
			<div className="col-span-2 flex items-center justify-between">
				<p className="label">{t("absences.default_half_days")}</p>
			</div>
			{fields.map((field, index) => (
				<div
					key={field.id}
					className="col-span-2 h-stack items-end gap-4"
				>
					<Select
						label={t("dates.day")}
						control={methods.control}
						name={`halfVacationDays.${index}.day`}
						isNullable={false}
						isRequired
						options={Array.from({ length: 31 }).map((_, i) => ({
							label: (i + 1).toString().padStart(2, "0"),
							value: i + 1,
							item: { day: i + 1 },
						}))}
					/>
					<Select
						label={t("dates.month")}
						control={methods.control}
						name={`halfVacationDays.${index}.month`}
						isNullable={false}
						isRequired
						options={Array.from({ length: 12 }).map((_, i) => ({
							label: moment().startOf("year").add(i, "month").format("MMMM"),
							value: i + 1,
							item: { month: i + 1 },
						}))}
					/>
					<Button
						variant="danger-ghost"
						onClick={() => remove(index)}
						size="sm"
						icon={
							<Icon
								name="Trash"
								color="var(--color-red-500)"
							/>
						}
					/>
				</div>
			))}
			<div className="col-span-2 h-stack justify-end">
				<Button
					onClick={() => append({ day: 1, month: 1 })}
					icon={<Icon name="Plus" />}
				>
					{t("absences.add_half_day")}
				</Button>
			</div>
		</>
	);
}
